import { IPoi } from "~/interfaces";
import Content from "./content";
import { getTrafficFeedbackDetail } from "~/util/providers/traffic-feedback";
import { node } from "~/util/dom";
import { dateFormat } from "~/util/format";

const POPUP_HEADERS = ["Datum a čas", "Jméno", "Typ"];

export default class DetailDiInfo extends Content<IPoi> {
	_build() {
		this._dom.container.classList.add("content-detail-di-info");

		if (Mapy.CUS.editorial?.interface) {
			this._load();
		}
	}

	async _load() {
		const detailData = await getTrafficFeedbackDetail(this._data.id as number);

		if (detailData) {
			const elem = node("div", { className: "di-info__infoLine" });
			const popup = node("div", { className: "di-info__popup" });
			const header = node("div", { className: "di-info__popupHeader" });
			const items = node("div", { className: "di-info__popupItems" });

			elem.innerHTML = `NE = dnes ${detailData.sum.noToday}, celkem ${detailData.sum.no} | ANO = celkem ${detailData.sum.yes}`;
			elem.addEventListener("click", () => {
				if (popup.parentNode) {
					popup.remove();
				} else {
					this._dom.container.append(popup);
				}
			});
			POPUP_HEADERS.forEach(headerItem => {
				const headerElem = node("span", { className: "di-info__popupHeaderItem" });

				headerElem.textContent = headerItem;
				header.append(headerElem);
			});
			detailData.data.forEach(item => {
				const itemElem = node("div", { className: "di-info__popupItem" });
				const itemLineElem = node("div", { className: "di-info__popupItemLine" });
				const dateElem = node("span");
				const nameElem = node("span");
				const typeElem = node("span");
				const dateObj = new Date(item.date);

				dateElem.textContent = dateFormat(dateObj);
				nameElem.textContent = item.name;
				typeElem.textContent = item.type === 1 ? "ANO" : "NE";
				itemLineElem.append(dateElem, nameElem, typeElem);
				itemElem.append(itemLineElem);

				if (item.note) {
					const itemLineNoteElem = node("div", { className: "di-info__popupItemNoteLine" });
					const noteElem = node("p", { textContent: item.note });

					itemLineNoteElem.append(noteElem);
					itemElem.append(itemLineNoteElem);
				}

				items.append(itemElem);
			});

			popup.append(header, items);

			this._dom.container.append(elem);
		}
	}
}
